/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JiraSpaPageContainerEntryEntrypointProps } from './common/ui/page-container/JiraSpaPageContainerEntry.entrypoint.types.tsx';
import JiraSpaPageContainerQuery, {
	type JiraSpaPageContainerQuery as JiraSpaPageContainerQueryType,
} from './common/ui/page-container/__generated__/JiraSpaPageContainerQuery.graphql';

type SpaEntryPointComponent = EntryPointComponent<
	{
		queryReference: JiraSpaPageContainerQueryType;
	},
	{},
	JiraSpaPageContainerEntryEntrypointProps,
	{}
>;

export const spaEntryPoint: EntryPoint<SpaEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<SpaEntryPointComponent>(
			/* webpackChunkName: "async-page-container" */ './common/ui/page-container/JiraSpaPageContainerEntry.tsx',

			{
				// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
				includeInShellOnlySsrBundle: true,
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: (props: EntryPointRouteParams) => ({
			queries: {
				queryReference: {
					parameters: JiraSpaPageContainerQuery,
					variables: {
						cloudId: props?.tenantContext?.cloudId,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		}),
	});
